import { z } from 'zod'

import { CompanySchema } from '@/api/_schemas/companies'

const UserSchema = z.object({
  cod_pessoa: z.number(),
  nome: z.string(),
  cpf: z.string(),
  email: z.string(),
  empresa: CompanySchema,
  admin: z.boolean(),
})

type User = z.infer<typeof UserSchema>

const AuthenticateBodySchema = z.object({
  email: z.string().min(1, 'E-mail obrigatório'),
  senha: z.string().min(1, 'Senha obrigatória'),
})

type AuthenticateBody = z.infer<typeof AuthenticateBodySchema>

const AuthenticateBodyByTokenSchema = z.object({
  token: z.string().min(1, 'Token obrigatório'),
  app: z.string(),
})

type AuthenticateBodyByToken = z.infer<typeof AuthenticateBodyByTokenSchema>

const AuthenticateSchema = z.object({
  token_bf: z.string(),
  token_agp: z.string(),
  pessoa: UserSchema,
})

type Authenticate = z.infer<typeof AuthenticateSchema>

const CreateAccountBodySchema = z.object({
  cpf: z.string().min(1, 'CPF obrigatório'),
  nome: z.string().min(1, 'Nome obrigatório'),
  'e-mail': z.string().min(1, 'E-mail obrigatório'),
  usuario: z.object({
    senha: z.string().min(1, 'Senha obrigatória'),
  }),
})

type CreateAccountBody = z.infer<typeof CreateAccountBodySchema>

const ForgotPasswordBodySchema = z.object({
  email: z.string().min(1, 'E-mail obrigatório'),
})

type ForgotPasswordBody = z.infer<typeof ForgotPasswordBodySchema>

const ResetPasswordBodySchema = z.object({
  password: z.string().min(1, 'Senha obrigatória'),
  password_confirmation: z.string().min(1, 'Senha obrigatória'),
})

type ResetPasswordBody = z.infer<typeof ResetPasswordBodySchema>

const ResetPasswordParamsSchema = z.object({
  token: z.string(),
})

type ResetPasswordParams = z.infer<typeof ResetPasswordParamsSchema>

export {
  UserSchema,
  CreateAccountBodySchema,
  AuthenticateBodySchema,
  AuthenticateBodyByTokenSchema,
  AuthenticateSchema,
  ForgotPasswordBodySchema,
  ResetPasswordBodySchema,
  ResetPasswordParamsSchema,
  type User,
  type CreateAccountBody,
  type AuthenticateBody,
  type AuthenticateBodyByToken,
  type ForgotPasswordBody,
  type ResetPasswordBody,
  type ResetPasswordParams,
  type Authenticate,
}
